import Vue from 'vue';

export const SET_FEEDBACK_MSG = 'SET_FEEDBACK_MSG';

const storageModule = {
  namespaced: true,
  state: {
    lastPlp: null,
    bikeTechSKU: null,
    feedbackMsg: '',
    purchaseMode: localStorage.purchaseMode ? localStorage.purchaseMode : false,
  },
  getters: {
    purchaseMode(state) {
      return state.purchaseMode;
    },
  },
  mutations: {
    setBikeTechSKU(state, sku) {
      Vue.set(state, 'bikeTechSKU', sku);
    },
    setLastPlp(state, value) {
      Vue.set(state, 'lastPlp', value);
    },
    setPurchaseMode(state, value) {
      Vue.set(state, 'purchaseMode', value);
    },
    [SET_FEEDBACK_MSG](state, message) {
      state.feedbackMsg = message;
    },
  },
  actions: {
    setFeedbackMsg({commit}, message) {
      commit(SET_FEEDBACK_MSG, message);
    },
    togglePurchaseMode({commit, state}) {
      let value = !state.purchaseMode;
      commit('setPurchaseMode', value);
    },
  },
};

export default storageModule;
